"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CursorPaginationDirection = exports.ReportDuration = exports.ReportSortDirection = exports.UserReportSortColumns = void 0;
var UserReportSortColumns;
(function (UserReportSortColumns) {
    UserReportSortColumns["username"] = "Username";
    UserReportSortColumns["email"] = "Email";
    UserReportSortColumns["createAt"] = "CreateAt";
    UserReportSortColumns["firstName"] = "FirstName";
    UserReportSortColumns["lastName"] = "LastName";
    UserReportSortColumns["nickname"] = "Nickname";
})(UserReportSortColumns || (exports.UserReportSortColumns = UserReportSortColumns = {}));
var ReportSortDirection;
(function (ReportSortDirection) {
    ReportSortDirection["ascending"] = "asc";
    ReportSortDirection["descending"] = "desc";
})(ReportSortDirection || (exports.ReportSortDirection = ReportSortDirection = {}));
var ReportDuration;
(function (ReportDuration) {
    ReportDuration["AllTime"] = "all_time";
    ReportDuration["Last30Days"] = "last_30_days";
    ReportDuration["PreviousMonth"] = "previous_month";
    ReportDuration["Last6Months"] = "last_6_months";
})(ReportDuration || (exports.ReportDuration = ReportDuration = {}));
var CursorPaginationDirection;
(function (CursorPaginationDirection) {
    CursorPaginationDirection["prev"] = "prev";
    CursorPaginationDirection["next"] = "next";
})(CursorPaginationDirection || (exports.CursorPaginationDirection = CursorPaginationDirection = {}));
